import { AxiosResponse } from 'axios';
import {
  IB2BAddress,
  IB2BUpdateAddressResponse,
  IB2BDeleteAddressResponse,
  TB2BRequestAddressData,
  THMACResponse,
} from '../../models/b2b/addresses';
import {
  B2B_ADDRESSES_PATH,
  B2B_UPDATE_ADDRESSES_PATH,
  B2B_ACCOUNT_PATH,
} from '../../constants/links';
import { apiB2B } from '../axios-client';
import { withUserId, withUserContext } from '../utils';

export const b2bAddressesApi = {
  addNewAddress: withUserId(
    (
      userId,
      address: TB2BRequestAddressData,
    ): Promise<AxiosResponse<IB2BUpdateAddressResponse>> => {
      return apiB2B.post(B2B_UPDATE_ADDRESSES_PATH(userId), {
        addressRequest: {
          address: [address],
        },
      });
    },
  ),

  deleteAddress: withUserContext(
    (
      userId,
      svocId,
      { addrIdentifier, userId: ownerUserId }: Partial<IB2BAddress>,
    ): Promise<AxiosResponse<IB2BDeleteAddressResponse>> =>
      apiB2B.delete(`${B2B_ADDRESSES_PATH(userId, svocId)}/${addrIdentifier}`, {
        params: {
          ownerUserId,
        },
      }),
  ),
  editAddress: withUserId(
    (
      userId,
      ...addresses: Array<Partial<TB2BRequestAddressData>>
    ): Promise<IB2BUpdateAddressResponse> =>
      apiB2B
        .put<IB2BUpdateAddressResponse>(B2B_UPDATE_ADDRESSES_PATH(userId), {
          addressRequest: {
            address: addresses,
          },
        })
        .then(({ data }) => data),
  ),
  // This call is invoked server-side, so we cannot use withSvocId here since getSvocId relies on client-side context.
  // Instead, we will pass the svocId from the server when invoking this function.
  ogHmac: ({
    customerSVOCId,
    host = '',
  }: {
    customerSVOCId: string;
    host?: string;
  }) => {
    const ogHmacUrl = new URL(
      `${B2B_ACCOUNT_PATH}/${customerSVOCId}/ogHmac`,
      host,
    );

    return apiB2B.get<THMACResponse>(ogHmacUrl.href, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
  },
};
